namespace TabAurous.Production {
    export interface MergingBOMRow {
        TransBomId?: number;
        TransItemId?: number;
        TransId?: number;
        ProductId?: number;
        BomProductId?: number;
        CalcOnId?: number;
        AttributeId?: number;
        ItemTypeId?: number;
        KaratId?: number;
        MetalColorId?: number;
        BagNo?: string;
        LotNo?: string;
        Line_No?: number;
        Pieces?: number;
        Weight?: number;
        Purity?: number;
        PureWeight?: number;
        IsCustomerItem?: boolean;
        Markup?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        UserId?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        RefTransBomId?: number;
        SettingId?: number;
        SettingName?: string;
        StoneStatusId?: number;
        StoneStatusName?: string;
        Lab?: string;
        CertificateNo?: string;
    }

    export namespace MergingBOMRow {
        export const idProperty = 'TransBomId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.MergingBOM';
        export const lookupKey = 'Production.MergingBOM';

        export function getLookup(): Q.Lookup<MergingBOMRow> {
            return Q.getLookup<MergingBOMRow>('Production.MergingBOM');
        }
        export const deletePermission = 'Production:Merging:Delete';
        export const insertPermission = 'Production:Merging:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:Merging:Edit';

        export declare const enum Fields {
            TransBomId = "TransBomId",
            TransItemId = "TransItemId",
            TransId = "TransId",
            ProductId = "ProductId",
            BomProductId = "BomProductId",
            CalcOnId = "CalcOnId",
            AttributeId = "AttributeId",
            ItemTypeId = "ItemTypeId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            BagNo = "BagNo",
            LotNo = "LotNo",
            Line_No = "Line_No",
            Pieces = "Pieces",
            Weight = "Weight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            IsCustomerItem = "IsCustomerItem",
            Markup = "Markup",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefTransBomId = "RefTransBomId",
            SettingId = "SettingId",
            SettingName = "SettingName",
            StoneStatusId = "StoneStatusId",
            StoneStatusName = "StoneStatusName",
            Lab = "Lab",
            CertificateNo = "CertificateNo"
        }
    }
}
